export default __webpack_public_path__ + "static/1401-9b91a724aa585eedd0be8e7cc788b84e.gif";